export const createPromise = () => {
    let resolver;
    return [new Promise((resolve, reject) => {

        resolver = resolve
    }), resolver]
}
